<template>
  <v-card
    flat
    :disabled="disabled"
    @click="selectTab"
    class="tab-container"
    :class="{ 'ml-0': index === 0 }"
  >
    <div class="innerContainer">
      <h3 :class="{ selectedColor: selected }">{{ title }}</h3>
      <p class="subtitle mt-4">{{ subTitle }}</p>
    </div>
    <div class="py-1" :class="{ selected: selected }"></div>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      selected: this.isSelected
    };
  },
  props: {
    index: Number,
    isSelected: {
      default: false
    },
    title: [String, Number],
    subTitle: [String, Number],
    disabled: [Boolean]
  },
  methods: {
    selectTab() {
      this.selected = !this.selected;
      this.$emit('getSelected', { index: this.index, status: this.selected });
    }
  }
};
</script>
<style>
.tab-container {
  flex: 1;
  padding: 0px;
  border: 1px solid #eee !important;
  text-align: center;
  margin-left: 10px;
}
.innerContainer {
  padding: 16px;
  padding-bottom: 0px;
}
.subtitle {
  font-size: 12px;
  color: #525252;
}
.selectedColor {
  color: #58e2c2 !important;
}
.selected {
  background-color: #58e2c2 !important;
}
</style>
